import React, { createContext, useContext, useReducer, useMemo, useEffect } from 'react';

import { reducer, initState, getActions } from '../services';
import { updateSDK } from '../services/sdk';

interface ServiceProviderProps {
  children: React.ReactNode;
  projectId: string;
  includePermission?: boolean;
  region?: string;
}

const ServiceContext = createContext<{
  state: typeof initState;
  dispatch: ReturnType<typeof getActions>;
}>({
  state: initState,
  dispatch: {} as ReturnType<typeof getActions>
});
const ServiceProvider: React.FC<ServiceProviderProps> = ({ children, projectId, includePermission, region }) => {
  const [state, dispatcher] = useReducer(reducer, initState);
  const dispatch = useMemo(
    () => getActions({ dispatch: dispatcher, projectId, includePermission }),
    [projectId, includePermission]
  );

  useEffect(() => {
    // potentially update sdk instance if a different region is passed in
    updateSDK({ region });
  }, [region]);

  useEffect(() => {
    // Get current user
    if (projectId) dispatch.getCurrentUser();
  }, [projectId, dispatch]);

  return <ServiceContext.Provider value={{ state, dispatch }}>{children}</ServiceContext.Provider>;
};

const useService = () => useContext(ServiceContext);

export { ServiceProvider, useService };
